import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Clock from '@deliveroo/icon-set/react/Clock';
import Pin from '@deliveroo/icon-set/react/Pin';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Modal from '@deliveroo/consumer-component-library/components/Modal';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Span from '@deliveroo/consumer-component-library/components/Span';

import i18n from '../../utils/i18n';
import HomeFiltersFulfillmentControl from '../../containers/HomeFiltersFulfillmentControl';
import HomeFiltersFulfillmentControlMobile from '../../containers/HomeFiltersFulfillmentControlMobile';
import ChangeRow from './ChangeRow';
import styles from './styles.scss';

class HomeFeedLogisticsModal extends Component {
  componentDidMount() {
    this.props.trackViewedLogisticsControl();
  }

  renderFooter = () => (
    <Button isBlock onClick={this.props.onClose}>
      {i18n.gettext('Confirm')}
    </Button>
  );

  render() {
    const {
      city,
      dateTimeLabel,
      onClose,
      neighborhood,
      postcode,
      showFulfillmentSwitchControl,
      showLocationSearchModal,
      toggleDateTimeModal,
      isChangeTimeAllowed,
      withClickAndCollect,
    } = this.props;
    const firstLocationLine = [neighborhood, postcode].filter(Boolean).join(', ');
    return (
      <Modal
        isOpen
        id="logistics-modal"
        appElement="#__next"
        type="bottomSheet"
        onClose={onClose}
        closeButtonLabel={i18n.gettext('closeButton.label')}
        headerTitle={
          withClickAndCollect
            ? i18n.gettext('home.logistics_modal.modalTitle')
            : i18n.gettext('home.logistics_modal.title')
        }
        renderFooter={this.renderFooter}
      >
        <div className={classnames({ [styles.titleWrapper]: withClickAndCollect })}>
          <Span isBlock isBold spacing="0 0 medium 0">
            {withClickAndCollect
              ? i18n.gettext('home.logistics_modal.where_and_when')
              : i18n.gettext('Delivery address')}
          </Span>
        </div>
        {withClickAndCollect &&
          showFulfillmentSwitchControl && (
            <Spacer spacing="small 0 x-large 0">
              <div className={styles.desktopWrapper}>
                <HomeFiltersFulfillmentControl inputName="logistics-modal__fulfillment-method" />
              </div>
              <div className={styles.mobileWrapper}>
                <HomeFiltersFulfillmentControlMobile inputName="logistics-modal__fulfillment-method" />
              </div>
            </Spacer>
          )}
        <ChangeRow
          icon={Pin}
          contentLines={[firstLocationLine, city]}
          onClick={() => showLocationSearchModal()}
        />
        {!withClickAndCollect && (
          <Span isBlock isBold spacing="x-large 0 medium 0">
            {i18n.gettext('restaurant_list.time_picker.modal.title')}
          </Span>
        )}
        <Spacer spacing={withClickAndCollect ? 'large 0' : ''}>
          <ChangeRow
            icon={Clock}
            contentLines={[dateTimeLabel]}
            isDisabled={!isChangeTimeAllowed}
            onClick={() => toggleDateTimeModal(true)}
          />
        </Spacer>
      </Modal>
    );
  }
}

HomeFeedLogisticsModal.propTypes = {
  city: PropTypes.string.isRequired,
  dateTimeLabel: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  neighborhood: PropTypes.string.isRequired,
  postcode: PropTypes.string.isRequired,
  showLocationSearchModal: PropTypes.func.isRequired,
  toggleDateTimeModal: PropTypes.func.isRequired,
  trackViewedLogisticsControl: PropTypes.func.isRequired,
  isChangeTimeAllowed: PropTypes.bool.isRequired,
  withClickAndCollect: PropTypes.bool.isRequired,
  showFulfillmentSwitchControl: PropTypes.bool.isRequired,
};

export default HomeFeedLogisticsModal;
